export default [
  'getRoleType',
  'systemSet',
  'applyManageAdd', 
  'addSite', 
  'addBatch', 
  'editSite', 
  'editBatch', 
  'addSection', 
  'editSection', 
  'mockExam', 
  'systemMessage', 
  'addNotice', 
  'editNotice',
  'customForm',
  'addMajorCourse'
]